module.exports = __webpack_public_path__ + "img/open-packages.25fc6bd3.svg";